import { OpenInNew } from "@mui/icons-material";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const pdfDirectUrl = `${process.env?.["NX_APP_API_DOMAIN"] || ""}${
  process.env?.["NX_PRIVACY_POLICY_URL"] || ""
}`;

const PrivacyPage = () => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const objectUrlRef = useRef<string | null>(null);

  useEffect(() => {
    fetch(pdfDirectUrl)
      .then((res) => {
        if (!res.ok) throw new Error("fetch failed");
        return res.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        objectUrlRef.current = url;
        setBlobUrl(url);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });

    return () => {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
    };
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      sx={{
        height: {
          xs: "calc(100vh - 56px - 56px)",
          md: "calc(100vh - 69px - 56px)"
        }
      }}
    >
      <Box display="flex" justifyContent="flex-end" p={1}>
        <Button
          component="a"
          href={pdfDirectUrl}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
          endIcon={<OpenInNew />}
        >
          Apri PDF
        </Button>
      </Box>

      {loading && (
        <Box flex={1} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Box flex={1} display="flex" alignItems="center" justifyContent="center">
          <Typography>
            Impossibile caricare il documento.{" "}
            <a href={pdfDirectUrl} target="_blank" rel="noopener noreferrer">
              Aprilo direttamente qui
            </a>
            .
          </Typography>
        </Box>
      )}

      {blobUrl && (
        <Box
          component="iframe"
          src={blobUrl}
          title="Privacy Policy"
          sx={{ flex: 1, width: "100%", border: "none", minHeight: 0 }}
        />
      )}
    </Box>
  );
};

export default PrivacyPage;
